import { getIsNullish } from '../../jsUtils';

export const getValueOrDash = (
  value?: string | number | null,
  unit?: string,
  unitPosition: 'prefix' | 'suffix' = 'suffix',
) => {
  if (getIsNullish(value)) return '—';
  return unit
    ? `${unitPosition === 'prefix' ? unit : ''}${value}${unitPosition === 'suffix' ? unit : ''}`
    : value;
};
